<template>
    <ElementLayout :parent="parent" :element="element">
        <DateRangeList v-model="element.value" :label="element.title" :disabled="element.disabled" :hide-details="true" :single-line="false" />
    </ElementLayout>
</template>

<script>
import ElementLayout from '../ElementLayout' 
import DateRangeList from '../../ui-elements/DateRangeList'

export default {
    data() {
        return {
        
        }
    },

    components: {
        ElementLayout,
        DateRangeList,
    },
    
    props: {
        element: Object,
        parent: Object,
    },

    computed: {
        attributes() {

        }
    },

    methods: {
        function1() {

        },
    },
}
</script>

<style scoped>
   
</style>




// WEBPACK FOOTER //
// DateRangeControl.vue?61843f2a